import { Component, OnInit, Inject } from '@angular/core';
import { listPagesDB } from 'src/app/shared/tables/list-pages';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-summer-internships-heading-list',
  templateUrl: './summer-internships-heading-list.component.html',
  styleUrls: ['./summer-internships-heading-list.component.scss']
})
export class SummerInternshipsHeadingListComponent implements OnInit {

  constructor(private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public lists = [];
  message = null;
  class = null;

  ngOnInit() {
    this.http.get<any>(this.api_endpoint+'/summerInternshipsHeading/').subscribe(
      data => {
        this.lists = data.data;
        
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }

  delete(id) {
    // console.log(this.Form.value)
    if(confirm("Are you sure to delete ")){
    this.http.delete<any>(this.api_endpoint+'/summerInternshipsHeading/'+ id).subscribe(
      res => {
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Deleted';
          this.class = 'btn btn-success';
          this.ngOnInit();
        }
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });
  }
  }

}
